module.exports = __webpack_public_path__ + "img/164w.fd53fa1.jpg";